import React, { Component, useReducer } from 'react';
import {Collapse,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import HomeImage from '../images/home.png'
import Image_1 from '../images/image_1.jpg'
import Image_2 from '../images/image_2.jpg'
import Image_3 from '../images/image_3.jpg'


  class Home extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        videos: []
      };
      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.CheckForVideos = () => {
        var videos = this.state.videos
        var videos_map = videos.map((video, index) => {
            return<Row style={{width: '557px', margin: '5px', height: '340px', overflow: 'hidden', marginBottom: '35px'}}>
                <Col>
                <video width="557" height="312" controls>
                    <source src={video.url} type="video/mp4"/>
                    Your browser does not support the video tag.
                </video>
                <br/>
                <p style={{fontWeight: 'bold'}}>
                    {video.name}
                </p>
                </Col>
            </Row>
        })

        if(videos.length == 0){
          return<div>
            <br/>
            <h4 style={{marginTop: '100px', textAlign: 'center', marginBottom: '170px'}}>
              No videos have been uploaded yet.
            </h4>
          </div>
        }else{
          return<Row style={{marginTop: '70px'}}>
              {videos_map}
          </Row>
        }
      }
    }

    componentDidMount() {
      const { cookies } = this.props;

      var data = new FormData()
      data.append('user_access_token', cookies.get('token'))

      axios.post(Backend_Url + 'homeVideos', data)
      .then((res) => {
          let result = res.data
          result.forEach(video => video['video'] = Backend_Url + 'videos/' + video['video']);
          this.setState({videos: result})
      }).catch((error) => {
          console.log(error)
      })
    }




    render() {
      return (
        <div style={{minHeight: '550px', backgroundColor: ''}}>
            <Helmet>
              <title>HOME - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#F5F5F5'}}>
              <Container>
                <Row>
                  <Col style={{textAlign: 'left'}} sm='6'>
                    <h1 style={{color: '#39393c', fontSize: '42px', fontWeight: 'bold', lineHeight: '38px', marginTop: '120px'}}>
                      Virtual Personal Training.
                    </h1>
                    <h2 style={{color: '#606366', marginTop: '30px', fontSize: '17px', fontWeight: '300', lineHeight: '20px'}}>
                      On demand service to train live with your personal trainer whenever you want and wherever you are.
                    </h2>
                    <br/><br/>
                    <h4 style={{textAlign: 'center'}}>
                      Signup Here
                    </h4>
                    <Row>
                      <Col>
                        <Button href={'/signup/user/direct'} style={{marginTop: '30px', backgroundColor: '#1faced', color: '#FFFFFF', border: 'none', borderRadius: '20px', width: '80%'}}>
                          USER
                        </Button>
                      </Col>
                      <Col>
                        <Button href={'/signup/trainer'} style={{marginTop: '30px', backgroundColor: '#1faced', color: '#FFFFFF', border: 'none', borderRadius: '20px', width: '80%'}}>
                          TRAINER
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                  <Col sm='6'>
                      <img src={HomeImage} style={{width: '90%'}}/>
                  </Col>
                </Row>
              </Container>
            </div>
            <Container>
              <br/><br/><br/><br/>
              <h4  style={{color: '#3C1874', fontWeight: 'bold'}}>
                  WHAT IS ONFIT?
              </h4>
              <br/>
              <p style={{textAlign: 'left'}}>
                A Virtual Personal Training Platform that provides a two way interaction between trainers and users.
                Its a first of its kind platform that enables fitness profesionals to manage clients, create customisable training and nutrition plans, track progress, acquire new clients and host live sessions all in one.
                Users have a access to a wide variety of personal trainers tailored to suit their needs at anytime and anywhere they are and can be a part of a community of other fitness users.
              </p>
              <br/><br/><br/><br/>
              <h4  style={{color: '#3C1874', fontWeight: 'bold'}}>
                  WHAT WE OFFER OUR USERS
              </h4>
              <br/>
              <p style={{color: '#8190A5', fontSize: '14px', lineHeight: '34px', textAlign: 'center'}}>
                Complete the application form if interested in the Basic Plan Pre-sign up. No credit card 
                required but spaces for the programs may be limited at the start so access will be granted 
                on a first come basis. <a href='/pricing' style={{color: '#1faced'}}>Click here if interested.</a>
              </p>
                <Row>
                  <Col sm='6'>
                    <img src={Image_2} style={{width: '100%'}}/>
                  </Col>
                  <Col>
                    <h3 style={{fontSize: '28px', color: '#39393c', fontWeight: 'bold', marginTop: '50px'}}>
                      Train with us, join the movement.
                    </h3>
                    <p style={{marginTop: '80px', textAlign: 'left', fontSize: '14px', fontWeight: '300'}}>
                      <ul>
                        <li>
                          Personalized training experience with a wide range of trainers, nutritionists and physiotherapists.
                        </li>
                        <br/>
                        <li>
                          On demand training services with real time progress tracking tools.
                        </li>
                        <br/>
                        <li>
                          Gym equipment rental services.
                        </li>
                      </ul>
                    </p>
                  </Col>
                </Row>
              <br/><br/><br/><br/>
              <h4  style={{color: '#3C1874', fontWeight: 'bold'}}>
                  TRAINERS
              </h4>
              <br/><br/>
                <Row>
                  <Col>
                    <h3 style={{fontSize: '28px', color: '#39393c', fontWeight: 'bold', marginTop: '50px'}}>
                      Take your business to the next level with us.
                    </h3>
                    <p style={{marginTop: '80px', textAlign: 'left', fontSize: '14px', fontWeight: '300'}}>
                      <ul>
                        <li>
                          All in one platform where you can host live training services, market your brand, acquire new customers and manage bookings.
                        </li>
                        <br/>
                        <li>
                          Partner with us and earn money through using our platform to provide seamless training experience to your client wherever you are.
                        </li>
                      </ul>
                    </p>
                  </Col>
                  <Col sm='6'>
                    <img src={Image_3} style={{width: '100%'}}/>
                  </Col>
                </Row>
                <br/><br/>
            </Container>
            <br/><br/><br/>
        </div>
      );
    }

  };
  
  export default withCookies(Home);